import useSendGTMAction from 'features/google-tag-manager/hooks/useSendGTMAction';
import { HelpCenterClickedGtmAction } from 'features/google-tag-manager/model/actions/help_center_clicked.gtm-action';
import { useCallback } from 'react';
import useHelpCenterLink, { HelpCenterLinkType } from './useHelpCenterLink';

type UseOpenHelpCenter = (id: number | string, type: HelpCenterLinkType, position: string) => () => void;

/**
 * Opens a help center link in a new tab and reports the click via GTM (`HelpCenterClickedGtmAction`,
 * tagged with `position` so different help-center entry points are distinguishable in reporting).
 */
const useOpenHelpCenter: UseOpenHelpCenter = (id, type, position) => {
    const sendGTMAction = useSendGTMAction();
    const helpCenterLink = useHelpCenterLink(id, type);

    return useCallback(() => {
        sendGTMAction(new HelpCenterClickedGtmAction({ position }));
        open(helpCenterLink, '_blank');
    }, [sendGTMAction, helpCenterLink, position]);
};

export default useOpenHelpCenter;
